import {
  MARKETING_GET_PRIMARY_INTERESTS,
  MARKETING_GET_PRIMARY_INTERESTS_SUCCESS,
  MARKETING_GET_PRIMARY_INTERESTS_ERROR,
} from './type'

/**
 * Get primary interests action
 */
export const marketingGetPrimaryInterestsAction = () => {
  return {
    type: MARKETING_GET_PRIMARY_INTERESTS,
    payload: {},
  }
}

/**
 * Get primary interests success
 * @param {*} response
 */
export const marketingGetPrimaryInterestsSuccess = response => {
  return {
    type: MARKETING_GET_PRIMARY_INTERESTS_SUCCESS,
    payload: { response },
  }
}

/**
 * Get primary interests error
 */
export const marketingGetPrimaryInterestsError = () => {
  return {
    type: MARKETING_GET_PRIMARY_INTERESTS_ERROR,
  }
}
